module.exports = __webpack_public_path__ + "img/envelope-icon-green.a831fc74.svg";